// Which page a project record renders as. Mirrors server/projectType.js —
// keep the two in step.
//
// A "project" is one record fetched from /api/project: a donation campaign or a
// petition. The record itself says which, in its `project_type` field, and that
// is what picks the page component. Gramsci doesn't send the field yet, so an
// absent one reads as Campaign — every record this app has ever fetched was one.

export const CAMPAIGN = 'Campaign';
export const PETITION = 'Petition';
const KNOWN_TYPES = [CAMPAIGN, PETITION];

// The type a record declares, normalized. Unknown/missing/null => Campaign.
export function projectTypeOf(record) {
  const raw = String((record && record.project_type) || '').toLowerCase();
  return KNOWN_TYPES.find((t) => t.toLowerCase() === raw) || CAMPAIGN;
}

export function isPetition(record) {
  return projectTypeOf(record) === PETITION;
}
